import React, { useState, useEffect } from "react";
import VendorsMap from "./VendorsMap";
import Vendor from "../payments/types/Vendor";

export default function App() {
  // const baseUrl =
  //   window.location.host === "dev-megaphone-wordpress.pantheonsite.io"
  //     ? "https://megaphone-magazine-staging-d857d30ff8e7.herokuapp.com"
  //     : "http://localhost:3000";
  const baseUrl = "https://app.megaphonemagazine.com";
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<null | string>(null);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [location, setLocation] = useState<string>("Vancouver");

  useEffect(() => {
    if (vendors.length > 0) {
      return;
    }

    Promise.all([fetch(baseUrl + "/vendors.json")])
      .then((responses) => {
        const errors = responses.filter((response) => !response.ok);
        if (errors.length > 0) {
          throw errors.map((response) => Error(response.statusText));
        }
        const json = responses.map((response) => response.json());
        return Promise.all(json);
      })
      .then((data) => {
        setLoading(false);
        setVendors(data[0]);
      })
      .catch((errors) => {
        setLoading(false);
        console.error(errors);
        setError("Something went wrong fetching the vendors.");
      });
  });

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <>
          {/* <div className="location font-size-s">
            <button
              className="button"
              onClick={() => setLocation("Vancouver")}
              disabled={location === "Vancouver"}
            >
              Vancouver
            </button>
            <button
              className="button"
              onClick={() => setLocation("Victoria")}
              disabled={location === "Victoria"}
            >
              Victoria
            </button>
          </div> */}
          <VendorsMap city={location} vendors={vendors} />
        </>
      )}
    </>
  );
}
